import {
  type SalesPartnerBasicData,
  type SalesPartnerBasicDataDTO,
} from "~/domains/salesPartner/types/SalesPartnerTypes";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export function getCompanyList(keyword: string): Promise<SalesPartnerBasicData> {
  const url = createUrlFromInputValues(keyword);

  return occFetch(url).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response.json().then((dto: SalesPartnerBasicDataDTO) => normalizeSalesPartnerBasicData(dto));
    }
  });
}

export function normalizeSalesPartnerBasicData(dto: SalesPartnerBasicDataDTO): SalesPartnerBasicData {
  return {
    countryCode: dto.countryCode ?? "",
    autosuggestResults: dto.autosuggestResults ?? [],
  };
}

export function createUrlFromInputValues(keyword: string): string {
  const params = new URLSearchParams();
  params.set("keyword", keyword);

  return occUrl(`/store-finder/basic-data?${params}`);
}
